import * as yup from "yup";

export const validationSchema = yup.object({
  powerLossCoefficient: yup.number()
    .typeError('Should be a number')
    .required("Power loss is required"),
  interferenceLevel: yup.number()
    .typeError('Should be a number')
    .required("Interference level is required"),
});